import { array } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import OnboardingStepsAccountSetupComponent from 'webapp/components/onboarding/steps/account-setup';
import OnboardingStepsDboxIntroComponent from 'webapp/components/onboarding/steps/dbox-intro';
import OnboardingStepsFinalComponent from 'webapp/components/onboarding/steps/final';
import OnboardingStepsGenieExpComponent from 'webapp/components/onboarding/steps/genie-exp';
import OnboardingStepsIntegrationsComponent from 'webapp/components/onboarding/steps/integrations';
import OnboardingStepsWelcomeComponent from 'webapp/components/onboarding/steps/welcome';

import { Step } from 'webapp/services/onboarding';

export default class OnboardingRouteTemplate extends Component {
	@service('onboarding') declare onboardingService: Service.Onboarding;

	get currentStep() {
		return this.onboardingService.currentStep;
	}

	get isStepWelcome() {
		return this.currentStep === Step.WELCOME;
	}

	get isStepAccountSetup() {
		return this.currentStep === Step.ACCOUNT_SETUP;
	}

	get isStepIntegrations() {
		return this.currentStep === Step.INTEGRATIONS;
	}

	get isStepDboxIntro() {
		return this.currentStep === Step.DBOX_INTRO;
	}

	get isStepFinal() {
		return this.currentStep === Step.FINAL;
	}

	get isStepGenieExp() {
		return this.currentStep === Step.GENIE_EXP;
	}

	<template>
		<div
			class={{joinClasses
				(array
					"onboarding"
					(if
						this.onboardingService.templateId
						"onboarding--template"
						"onboarding--regular"
					)
				)
			}}
		>
			{{#if this.isStepWelcome}}
				<div class="onboarding-step onboarding-step--welcome">
					<OnboardingStepsWelcomeComponent />
				</div>
			{{else if this.isStepAccountSetup}}
				<div class="onboarding-step onboarding-step--account-setup">
					<OnboardingStepsAccountSetupComponent />
				</div>
			{{else if this.isStepIntegrations}}
				<div class="onboarding-step onboarding-step--integrations">
					<OnboardingStepsIntegrationsComponent />
				</div>
			{{else if this.isStepDboxIntro}}
				<div class="onboarding-step onboarding-step--dbox-intro">
					<OnboardingStepsDboxIntroComponent />
				</div>
			{{else if this.isStepGenieExp}}
				<div class="onboarding-step onboarding-step--genie-exp">
					<OnboardingStepsGenieExpComponent />
				</div>
			{{else if this.isStepFinal}}
				<div class="onboarding-step onboarding-step--final">
					<OnboardingStepsFinalComponent />
				</div>
			{{/if}}
		</div>
	</template>
}
